class IncludeNumber {
    validate(data) {
        return {
            isValid: /\d/.test(data),
        };
    }
}
export default IncludeNumber;
